import { reducerWithInitialState } from 'typescript-fsa-reducers';
import * as lodash from 'lodash';
import { EstimateActions } from './estimate.action';
import { Estimate, EstimateListType, EstimateSortState } from '../../type/estimate/estimate.type';
import { EstimateCollection } from '../../collection/estimate/estimate.collection';
import { EstimateMeisaiSideMenu, EstimateMeisaiListType, EstimateMeisai } from '../../type/estimate/estimate-meisai.type';
import { concatList } from '../root.reducer';

export type EstimateState = {
  estimate: Estimate | null;
  list: EstimateListType[] | null;
  sort: EstimateSortState;
  estimateSearchSort: EstimateSortState;
  meisaiSideMenu: EstimateMeisaiSideMenu | null;
  meisaiList: EstimateMeisaiListType[];
  meisai: EstimateMeisai | null;
  isInitSort: boolean;
};

const initialState: EstimateState = {
  estimate: null,
  list: null,
  sort: EstimateCollection.sortInitialState,
  estimateSearchSort: EstimateCollection.sortInitialState,
  meisaiSideMenu: null,
  meisaiList: [],
  meisai: null,
  isInitSort: false,
};

export const EstimateReducer = reducerWithInitialState<EstimateState>(initialState)
  .case(EstimateActions.setEstimate, (state, payload) => ({
    ...state,
    estimate: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.setList, (state, payload) => ({
    ...state,
    list: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.setMeisaiList, (state, payload) => ({
    ...state,
    meisaiList: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.setMeisai, (state, payload) => ({
    ...state,
    meisai: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.setSort, (state, payload) => ({
    ...state,
    sort: payload ? lodash.cloneDeep({
      ...state.sort,
      ...payload,
    }) : EstimateCollection.sortInitialState,
  }))
  .case(EstimateActions.setInitSort, (state, payload) => ({
    ...state,
    sort: EstimateCollection._sortInitialState(payload),
  }))
  .case(EstimateActions.setEstimateSearchSort, (state, payload) => ({
    ...state,
    estimateSearchSort: payload ? lodash.cloneDeep({
      ...state.estimateSearchSort,
      ...payload,
    }) : EstimateCollection.sortInitialState,
  }))
  .case(EstimateActions.setEstimateSearchInitSort, (state, payload) => ({
    ...state,
    estimateSearchSort: EstimateCollection._sortInitialState(payload),
  }))
  .case(EstimateActions.setMeisaiSideMenu, (state, payload) => ({
    ...state,
    meisaiSideMenu: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.setIsInitSort, (state, payload) => ({
    ...state,
    isInitSort: lodash.cloneDeep(payload),
  }))
  .case(EstimateActions.resetState, () => initialState)
  .default((state) => state);
